import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import InfoCard from '../../components/InfoCard';
import LiquidContainer from '../../components/LiquidContainer';
import MainLanding from './MainLanding';

import agenda from '../../assets/icons/info_evento_icons/agenda_icon.svg';
import clima from '../../assets/icons/info_evento_icons/clima_icon_menu.svg';
import experiencias from '../../assets/icons/info_evento_icons/exp_whis_icon.svg';
import directorio from '../../assets/icons/info_evento_icons/directorio_icon.svg';
import links from '../../assets/icons/info_evento_icons/redes_icon.svg';
import recomendaciones from '../../assets/icons/info_evento_icons/recomendaciones_icon.svg';


const sectionsInfo = [
  {
    id: 'personalData',
    title: 'Datos Personales',
    content: 'Consulta y actualiza tu información personal',
    detail: 'Ver detalles',
    image: agenda,
    bckGndClr: '#023879'
  },
  {
    id: 'flights',
    title: 'Inormación de Vuelos',
    content: 'Conoce detalles de tus vuelos',
    detail: 'Explorar',
    image: experiencias,
    bckGndClr: '#34646d'
  },
  {
    id: 'tickets',
    title: 'Centro de ayuda',
    content: 'Escribenos para consultas o problemas',
    detail: 'Saber más',
    image: recomendaciones ,
    bckGndClr: '#3880f7'
  }
];

const Profile = () => {
  const [userData, setUserData] = useState({
    name: 'John Doe',
    email: 'johndoe@example.com',
    bio: 'A passionate developer who loves coding and learning new technologies.',
    profilePic: 'https://randomuser.me/api/portraits/men/32.jpg',
  });

  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState(userData.name);
  const [newEmail, setNewEmail] = useState(userData.email);
  const [newBio, setNewBio] = useState(userData.bio);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleSave = () => {
    setUserData({
      ...userData,
      name: newName,
      email: newEmail,
      bio: newBio,
    });
    setIsEditing(false);
  };

  return (
    <MainLanding>
      <div className='px-0'>
        <LiquidContainer backgroundColor="#efefefa7" ancho="85vw" alto="75vh" borderline= "0px" boxSdw="none">
          <div className='d-flex flex-column justify-content-center align-items-center my-3'>
            
            {sectionsInfo.map((section) => (
              <div key={section.id} className='row w-100 m-0 p-0'>
                <div className="col-12 d-flex justify-content-center align-items-center my-2">
                  <Link to={`/${section.id}`} className="d-block w-100 text-decoration-none text-black">
                  <LiquidContainer backgroundColor="#ffffff" borderline= "0px" radius="10px">
                      <InfoCard
                        imagen={section.image}
                        title={section.title}
                        bckGndClr={section.bckGndClr}
                      />
                  </LiquidContainer>
                  </Link>
                </div>
              </div>
            ))}

          </div>
        </LiquidContainer>
      </div>
    </MainLanding>
  );
};

export default Profile;
